import type { Task } from "@app/core";
import { useEffect, useState } from "react";
import { isPastEvent } from "./past-event.js";

const MAX_DELAY_MS = 0x7fffffff;

export function usePastEventFlag(task: Task): boolean {
  const [past, setPast] = useState(() => isPastEvent(task, new Date()));

  useEffect(() => {
    let id: ReturnType<typeof setTimeout> | null = null;
    const schedule = () => {
      setPast(isPastEvent(task, new Date()));
      const boundary = pastEventBoundaryMs(task);
      if (boundary === null || boundary < Date.now()) return;
      const delay = Math.min(boundary - Date.now() + 1000, MAX_DELAY_MS);
      id = setTimeout(schedule, delay);
    };
    schedule();
    return () => { if (id) clearTimeout(id); };
  }, [task.all_day, task.due_at, task.duration_minutes, task.id, task.is_event]);

  return past;
}

function pastEventBoundaryMs(task: Task): number | null {
  if (!task.is_event || !task.due_at) return null;
  const start = new Date(task.due_at);
  if (task.all_day) {
    const days = Math.max(1, Math.ceil(Math.max(0, task.duration_minutes) / 1440));
    const end = new Date(start);
    end.setDate(end.getDate() + days - 1);
    end.setHours(23, 59, 59, 999);
    return end.getTime();
  }
  return start.getTime() + Math.max(0, task.duration_minutes) * 60_000;
}
